import { addMinutes } from "date-fns/esm";

const getDefaultScheduleDate = (): Date => addMinutes(Date.now(), 3);

export default getDefaultScheduleDate;
